import { defineStore } from 'pinia';
import type { EvidenceCategory } from '../types/text-mode.types';

export interface EvidenceState {
  categories: EvidenceCategory[];
}

interface UpdateEvidenceValuePayload {
  itemId: string;
  value: string | number | boolean | null;
}

const initialCategories: EvidenceCategory[] = [
  {
    id: 'patient',
    title: 'Patient',
    items: [],
  },
  {
    id: 'vitals',
    title: 'Vitals',
    items: [],
  },
  {
    id: 'clinical-observations',
    title: 'Clinical Observations',
    items: [],
  },
];

export const useEvidenceStore = defineStore('textModeEvidence', {
  state: (): EvidenceState => ({
    categories: initialCategories.map(category => ({
      ...category,
      items: [...category.items],
    })),
  }),

  actions: {
    setEvidenceCategories(categories: EvidenceCategory[]): void {
      this.categories = categories;
    },

    updateEvidenceValue(payload: UpdateEvidenceValuePayload): void {
      this.categories = this.categories.map(category => ({
        ...category,
        items: category.items.map(item =>
          item.id === payload.itemId ? { ...item, value: payload.value } : item
        ),
      }));
    },

    reset(): void {
      this.categories = initialCategories.map(category => ({
        ...category,
        items: [],
      }));
    },

    resume(payload: EvidenceState): void {
      Object.assign(this, payload);
    },
  },
});
